import env from '../config/env';
import { assignHref, getHref } from './location';

const redirectToLogin = (): void => {
  const url = env.LOGIN_URL;
  assignHref(`${url}?origin=${getHref()}`);
};

const redirectToDashboard = (): void => {
  assignHref(env.SITE_URL);
};

export { redirectToLogin, redirectToDashboard };
